import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-expandable',
  templateUrl: './expandable.component.html',
  styleUrls: ['./expandable.component.scss']
})
export class ExpandableComponent implements OnInit {

  @Input() item;
  panelOpenState = false;

  constructor() { }

  ngOnInit() {
  }

}
